import { render, staticRenderFns } from "./ProductsGroupEditor.vue?vue&type=template&id=0b54bdb8"
import script from "./ProductsGroupEditor.vue?vue&type=script&lang=js"
export * from "./ProductsGroupEditor.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsGroupEditor.vue
// module id = 202
// module chunks = 0